import { integrationNames } from '@ardoq/integrations/integration-sources';
import { IntegrationInitialState } from 'integrations/common/initialStateTypes';
import { SERVICENOW_GUIDED_EXPORTER_INTEGRATION_ID } from 'integrations/common/streams/activeIntegrations/constants';
import { buildInitialTermsState } from 'integrations/common/streams/integrationTermsDictionary/initialState';

export const initialState: IntegrationInitialState = {
  activeIntegration: {
    integrationId: SERVICENOW_GUIDED_EXPORTER_INTEGRATION_ID,
    integrationMappingParams: {
      mapColumnsBy: 'sourceFieldName',
      mapTablesBy: 'id',
    },
  },
  termsDictionary: buildInitialTermsState({
    name: integrationNames['servicenow-guided-exporter'],
    integrationOverviewTitle: integrationNames['servicenow-guided-exporter'],
    overviewPrimaryButton: 'Create new export',
    // The below are required but not used in this exporter
    rightSidebarHeader: '',
    rightSideBarFAQ: [],
    connectYourAccountTitle: '',
    connectYourAccountBtn: '',
  }),
};
